// src/components/ShiftPress.jsx
import React from "react";
import styles from "./ShiftPress.module.css";

function ShiftPress({ hours = [], startTime, endTime, shiftTarget }) {
  const startHourNum = parseInt(startTime.split(":")[0], 10);
  const endHourNum   = parseInt(endTime.split(":")[0], 10);

  const filtered = (hours || [])
    .filter(h => {
      const hr = parseInt(h.hour, 10);
      return hr >= startHourNum && hr <= endHourNum;
    })
    .sort((a, b) => parseInt(a.hour, 10) - parseInt(b.hour, 10));

  const totalForShift = filtered.reduce((acc, it) => acc + (Number(it.count) || 0), 0);

  const labelForHour = (tileHour) => {
    if (tileHour === startHourNum) return startTime.slice(0, 5);
    if (tileHour === endHourNum)   return endTime.slice(0, 5);
    return `${String(tileHour).padStart(2, "0")}:00`;
  };

  return (
    <div className={styles.shiftContainer}>
      <div className={styles.headerRow}>
        <div className={styles.headerBox}>
          <div className={styles.headerLabel}>Shift Target</div>
          <div className={styles.headerValue}>{shiftTarget ?? "-"}</div>
        </div>
        <div className={styles.headerBox}>
          <div className={styles.headerLabel}>Total for shift</div>
          <div className={styles.headerValue}>{totalForShift}</div>
        </div>
      </div>

      {filtered.map((item, idx) => {
        const tileHour = parseInt(item.hour, 10);
        const timeLabel = labelForHour(tileHour);
        const count = Number(item.count) || 0;

        return (
          <div key={idx} className={styles.hourBlock}>
            <span className={styles.hourLabel}>{timeLabel}</span>
            <span className={styles.hourValue}>{count}</span>
          </div>
        );
      })}
    </div>
  );
}

export default ShiftPress;
